import { createStructuredSelector } from 'reselect';
import { getFormValues } from 'redux-form';
import { flow, get, constant } from 'lodash/fp';

import { isMonthlyPriceAvailableFeature } from 'modules/features';
import { PRICE_TYPE_NAME } from 'components/searchAds';

const getPriceType = (state, { formName }) =>
  flow(getFormValues(formName), get([PRICE_TYPE_NAME]))(state);

export default createStructuredSelector({
  priceType: getPriceType,
  showMonthlyPrice: constant(isMonthlyPriceAvailableFeature),
});
